import React, { useState } from 'react';
import './Skills.css';

const skillIcons = {
    'Speaking': '🗣️',
    'Listening': '👂',
    'Reading': '📖',
    'Writing': '✏️',
    'Grammar': '📚',
    'Vocabulary': '💭'
};

function Skills({ skillScores }) {
    // 1. AÑADIMOS UN ESTADO PARA SABER QUÉ HABILIDAD ESTÁ ACTIVA
    const [activeSkill, setActiveSkill] = useState(null);

    return (
        <div className="dp-skills-container dp-neumorphic">
            <h2 className="dp-section-title">Habilidades</h2>
            <div className="dp-skills-list">
                {skillScores && skillScores.length > 0 ? (
                    skillScores.map(skill => (
                        <div 
                            // 2. AÑADIMOS LA LÓGICA PARA LA CLASE 'active' Y EL MANEJO DEL CLIC
                            className={`dp-skill-item ${activeSkill === skill.skill_name ? 'active' : ''}`}
                            key={skill.skill_name}
                            onClick={() => setActiveSkill(skill.skill_name)}
                        >
                            <span className="dp-skill-name">
                                {skillIcons[skill.skill_name] || '🧠'} {skill.skill_name}
                            </span>
                            <span className="dp-skill-score">{skill.score} completados</span>
                        </div>
                    ))
                ) : (
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
                        Completa ejercicios para ver el progreso de tus habilidades.
                    </p>
                )}
            </div>
        </div>
    );
}

export default Skills;